import React from "react";
import { AttentionSeeker } from "react-awesome-reveal"; // Updated import
import logoSymbolIcon from 'icons/logo-symbol.svg'; // Import the logo symbol

const loadingStyle = {
  display: "block",
  position: "absolute",
  top: "50%",
  left: "50%",
  height: "300px",
  marginTop: "-150px",
  marginLeft: "-150px",
};

const Loading = () => (
  <AttentionSeeker effect="tada" repeat={true}>
    <img src={logoSymbolIcon} alt="loading logo" style={loadingStyle} />
  </AttentionSeeker>
);

export default Loading;
